import { City } from "../interfaces/city";

export function removeIndustrialCity(cityName: string) {
  const regex = /\s*Industrial\s*City$/i;
  const hasIndustrialCity = regex.test(cityName);
  const cleanedCityName = cityName.replace(regex, "").trim();

  return {
    cleanedName: cleanedCityName,
    wasRemoved: hasIndustrialCity,
  };
}

export function getCityName(
  city: City,
  language: string,
  fallback: string,
): string {
  if (language === "ar" && city.nameAr) {
    return city.nameAr;
  }
  if (language === "en" && city.nameEn) {
    return city.nameEn;
  }
  return fallback;
}
